import * as types from 'actions/menu/types';
import Platform from 'platform';

export const STATUSES = {
  IDLE: 'IDLE',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
};

const initialState = {
  status: STATUSES.IDLE,
  // just visual for player
  idle: false,
  data: [],
  isVisible: true,
};

const HardcodedPurchasesMenu = {
  dashboardTag: 'PURCHASES',
  id: 999,
  name: 'Purchases',
  names: { EN: 'Purchases', UA: 'Куплене' },
  title: 'Purchases',
  titles: { EN: 'Purchases', UA: 'Куплене' },
};

const HardcodedFiltersMenu = {
  dashboardTag: 'FILTERS',
  id: 111,
  name: 'Filters',
  names: { EN: 'Filters', UA: 'Фільтри' },
  title: 'Purchases',
  titles: { EN: 'Filters', UA: 'Фільтри' },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH:
      return { ...state, status: STATUSES.PENDING };
    case types.FETCH_SUCCESS:
      const filteredMenu = action.payload.filter((item) => item.dashboardTag);
      const radioMenuIndex = filteredMenu.findIndex((item) => item.dashboardTag === 'RADIO');
      const continueWatchingIndex = filteredMenu.findIndex((item) => item.dashboardTag === 'CONTINUE_WATCHING');
      const searchIndex = filteredMenu.findIndex((item) => item.dashboardTag === 'SEARCH');

      if (!isNaN(radioMenuIndex)) {
        filteredMenu.splice(radioMenuIndex, 1);
      }

      //Хардкодим покупки перед историей просмотра
      if (!isNaN(continueWatchingIndex) && Platform.getDeviceType() !== 'OLD_TV') {
        filteredMenu.splice(continueWatchingIndex, 0, HardcodedPurchasesMenu);
      }
      // TODO: improve
      if (searchIndex !== -1) {
        // set after the search
        filteredMenu.splice(searchIndex + 1, 0, HardcodedFiltersMenu);
      }

      return { ...state, data: filteredMenu, status: STATUSES.SUCCESS };
    case types.FETCH_ERROR:
      return { ...state, status: STATUSES.FAILED };
    case types.SET_IDLE:
      return { ...state, idle: action.payload };
    case types.SET_IS_VISIBLE:
      return { ...state, isVisible: action.payload };
    default:
      return state;
  }
};
